import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "element-basic-layout" }

import GlobalFooter from "@/components/GlobalFooter.vue";
import GlobalHeader from "@/components/GlobalHeader.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ElementBasicLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(GlobalHeader)
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createVNode(GlobalFooter)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})